import axios from 'axios';

const BASE_URL = '/api/v1/reviews';
const TIMEOUT_IN_MS = 15 * 1000;

const axiosClient = axios.create({
  timeout: TIMEOUT_IN_MS,
});

function buildUrl(...args) {
  return [BASE_URL, ...args].join('/');
}

function reportError(err) {
  console.error(err); // eslint-disable-line no-console
}

export {
  axiosClient,
  buildUrl,
  reportError,
};
